/**
 * createTheme takes in a template or ThemeInterface and returns the correct
 * BaseTheme CSS + custom styling for all components in your application
 *
 *
 * To ADD a new theme do the follow:
 * 1. Copy the files/folder from an existing theme there.
 * 2. Change the name to `theme<YourThemeNameHere>` and adjust the theme values, ex. `themePanelist`.
 * 3. Add the new theme name to the `Template` type in `createTheme.ts`.
 * 4. Import your new `CustomTheme` and add it to the themeDictionary in `createTheme.ts`.
 * 5. Add tests in `responsive.test.tsx` for your breakpoints.
 * 6. Update available basethemes in Storybook's dropdown `src/.storybook/preview.js`
 *
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import merge from 'deepmerge';
import { CintTheme } from './themeCint';
import { LucidTheme } from './themeLucid';
// All available themes for the createTheme function to choose from
export var themeDictonary = {
    LUCID: LucidTheme,
    CINT: CintTheme
};
export var createTheme = function (theme) {
    var defaultTheme = themeDictonary.LUCID;
    // if no theme is selected we return a default theme
    if (!theme)
        return defaultTheme;
    // if theme is an object we merge the chose BaseTheme with any potential enhancements
    if (typeof theme === 'object') {
        var template = theme.template, customThemeValues = __rest(theme, ["template"]);
        //if no template exists apply customizations to default theme
        if (!template)
            return merge(defaultTheme, customThemeValues);
        return merge(themeDictonary["" + template.toUpperCase()], customThemeValues);
    }
    // if no custom changes, return theme from dictionary
    return themeDictonary["" + (theme === null || theme === void 0 ? void 0 : theme.toUpperCase())];
};
//# sourceMappingURL=createTheme.js.map